$(document).ready(function () {

  $('.hero-swiper-button--prev').on('click', function () {
    $('.hero-swiper-button--prev').addClass('active');
    $('.hero-swiper-button--next').removeClass('active');
  });
  $('.hero-swiper-button--next').on('click', function () {
    $('.hero-swiper-button--next').addClass('active');
    $('.hero-swiper-button--prev').removeClass('active');
  });

  $('.questions__item').on('click', function () {
    $('.questions__item-answer').toggleClass('questions__item-answer-vis');
    $('.questions__item-img').toggleClass('questions__item-img-sm');
    $('.questions__item-wrap').toggleClass('questions__item-wrap-active');
  });
  $('.questions__item-2').on('click', function () {
    $('.questions__item-2-answer').toggleClass('questions__item-2-answer-vis');
    $('.questions__item-2-img').toggleClass('questions__item-2-img-sm');
    $('.questions__item-2-wrap').toggleClass('questions__item-2-wrap-active');
  });
  $('.questions__item-3').on('click', function () {
    $('.questions__item-3-answer').toggleClass('questions__item-3-answer-vis');
    $('.questions__item-3-img').toggleClass('questions__item-3-img-sm');
    $('.questions__item-3-wrap').toggleClass('questions__item-3-wrap-active');
  });
  $('.questions__item-4').on('click', function () {
    $('.questions__item-4-answer').toggleClass('questions__item-4-answer-vis');
    $('.questions__item-4-img').toggleClass('questions__item-4-img-sm');
    $('.questions__item-4-wrap').toggleClass('questions__item-4-wrap-active');
  });

  window.toggleMobileMenu = () => {
    $('.header__mobile-menu-m').toggleClass('open');
    $('.mobile__menu').toggleClass('mobile__menu-active');
    $('.mobile__user').toggleClass('mobile__user-active');
    // $('.header__logo').toggleClass('header__logo-active');
    $('.header__search').toggleClass('header__search-act');
    $('body').toggleClass('body-overflow ');
  }
  $('.header__mobile-menu').click(() => {
    window.toggleMobileMenu();
  });

  $(".header__search-input-button-wrap").click(function () {
    $(".header__search").addClass("header__search-active");
    $(".header__search-input-button").addClass("header__search-input-button-active");
    $(".header__search-input-wrap").addClass("header__search-input-wrap-active");
    $('.header__search-input-wrap').css('opacity', '1');
    $('.header__search-input-button-wrap').css('display', 'none');
    setTimeout(() => {
      $('#header-search').focus()
    }, 100);

    ;
  });
  $(".header__search-input-wrap-close").click(function () {
    $('.header__search-input-wrap').css('opacity', '0');
    $(".header__search").removeClass("header__search-active");
    $(".header__search-input-button").removeClass("header__search-input-button-active");
    $(".header__search-input-wrap").removeClass("header__search-input-wrap-active");
    $('.header__search-input-button-wrap').css('display', 'block');
  });


  $(".header__login-form-input-eye").click(function () {
    if ($('.header__login-form-input-pass').attr('type') == 'password') {
      $(".header__login-form-input-eye").addClass("header__login-form-input-eye-active");
      $('.header__login-form-input-pass').attr('type', 'text');
    } else {
      $(".header__login-form-input-eye").removeClass("header__login-form-input-eye-active");
      $('.header__login-form-input-pass').attr('type', 'password');
    }
    return false;
  });

  $('.games__new-slide').tilt({
    maxTilt: 15,
    perspective: 1000,
    scale: 1.1,
    speed: 600,
    transition: true,
  });

  new Swiper('#partners-slider', {
    // Optional parameters
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 0,
    loop: true,
    speed: 2500,

    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },

    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      1366: {
        slidesPerView: 7,
      }
    }
  });

  new Swiper('#top-partners-slider', {
    // Optional parameters
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 0,
    loop: true,
    speed: 2500,

    autoplay: {
      delay: 1000,
      reverseDirection: true,
      disableOnInteraction: false,
    },

    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
      1366: {
        slidesPerView: 4,
      }
    }
  });

  const swiperNews = new Swiper('.main_news_slider', {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,

    // If we need pagination
    pagination: {
      el: '.main_news_slider-pagination',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.main_news_slider-next',
      prevEl: '.main_news_slider-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1920: {
        slidesPerView: 3,
      },
    },
  });

  $('.main_news_slider-prev').click(() => {
    $('.main_news_slider-prev').addClass('main_news_slider_button_active');
    $('.main_news_slider-next').removeClass('main_news_slider_button_active');
  });
  $('.main_news_slider-next').click(() => {
    $('.main_news_slider-next').addClass('main_news_slider_button_active');
    $('.main_news_slider-prev').removeClass('main_news_slider_button_active');
  });

});
